// Creating new file: src/types/AuthTypes.ts
import { User, UserCredential } from "firebase/auth";
import { ReactNode } from "react";

export interface AuthProviderProps {
    children?: ReactNode;
}

export interface AppUser {
    user: User;
    role: string;
}

export interface AuthContextType {
    appUser: AppUser | null | undefined;
    signup: (email: string, password: string) => Promise<UserCredential>;
    signin: (email: string, password: string) => Promise<AppUser>;
    signinWithGoogle: () => Promise<AppUser>;
    emailVerification: (user: User) => Promise<void>;
    signout: () => Promise<void>;
}

export interface UserData {
    role: string;
}

export const DEFAULT_ROLE = "user";